/** Marketing-Website (Kauf / Registrierungs-Einstieg). */
export const MARKETING_ORIGIN = (
  import.meta.env.VITE_MARKETING_ORIGIN ??
  (import.meta.env.DEV ? "http://localhost:3334" : "https://www.capitalpilot.de")
).replace(/\/$/, "");

export function marketingUrl(path = "/"): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${MARKETING_ORIGIN}${p}`;
}
